<template>
  <main style="height: 100%;">
      <ParserLaunchDialog ref="parserDialog" @disableBnt="disableParserBtn"/>
      <header>
          <button @click="checkProDoctorov" :disabled="isProDoctorovButtonDisabled">
              <img class="icon icons8-Refresh-Filled" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACW0lEQVRoQ+2ZgU3EMAxFPxswAhsAG8AEwATABLABMAEwATABbABMAEyAmACYAPRRLeVyaWsnjlJOjXQ66c61/eLEdtI1rMhYWxEOzCBTi6RHRPYA7APY6j4WRg/7f/ZKFNH5SwAbFs8j2RL7C6pyFRHgtABAHs21v2Q6R9EVgBMHiNIVURQRLqf7BMQdAAK+OgGa1Vgj8h7tiW8AOy0BctZoKhrblSDWOwe/tKGxROQWwGGg+Nppw8e+EuKx+3EXgArGAvIS1Yka0RAI1iQO7jkVjAXkp1YN6PTGEGJOBTMVkD4INcwUQMYgVDCtQbQQozAtQawQgzAtQc4BnEUJ5A3AZvQbu4Yw7fPvAwAPoVxLEPoR1iZCsEv4TGTHUO64ey6716qVfukk6wYhWPz67FDuKQVh7T5rgdAP7hep4H12QpmlzqX10kq1UlkTNoMUHpOHmto5ItqWP2umtMoDuSw78x75T3vkqLstkYNNX8hvADz3FarWS4sQdDA8paVaB8pQliPZOrQESV0y8JQmx0/xjU0bZcOx1My1BGErwJ4m7kLHfJKmT3VZMKDMNWtZYbwgyOcKIo2cJjKeEFVANDDeENVAhmBqQFQFScHUgmBm5EWgDNqJs2UyT1haFEkAVCSnubFMZv0/vpbleV3q1KAuC4hEht+lKTblVBwNyqjrkhXEOsNaeULw4lpu4fnch+W1XmsQAvDtV2r5qKNBam+QuJhpIxLLXQDgvZd6TBHEDDG1iHBP8E3xwg2iNiStI8I6wc6azmcBCKg3iHYC3eVmEPcpLVS4MhH5Bc7cjTPVYyMFAAAAAElFTkSuQmCC" width="25" height="25">
              <span>ПроДокторов</span>
          </button>

          <button @click="checkZoon" :disabled="isZoonButtonDisabled">
              <img class="icon icons8-Refresh-Filled" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACW0lEQVRoQ+2ZgU3EMAxFPxswAhsAG8AEwATABLABMAEwATABbABMAEyAmACYAPRRLeVyaWsnjlJOjXQ66c61/eLEdtI1rMhYWxEOzCBTi6RHRPYA7APY6j4WRg/7f/ZKFNH5SwAbFs8j2RL7C6pyFRHgtABAHs21v2Q6R9EVgBMHiNIVURQRLqf7BMQdAAK+OgGa1Vgj8h7tiW8AOy0BctZoKhrblSDWOwe/tKGxROQWwGGg+Nppw8e+EuKx+3EXgArGAvIS1Yka0RAI1iQO7jkVjAXkp1YN6PTGEGJOBTMVkD4INcwUQMYgVDCtQbQQozAtQawQgzAtQc4BnEUJ5A3AZvQbu4Yw7fPvAwAPoVxLEPoR1iZCsEv4TGTHUO64ey6716qVfukk6wYhWPz67FDuKQVh7T5rgdAP7hep4H12QpmlzqX10kq1UlkTNoMUHpOHmto5ItqWP2umtMoDuSw78x75T3vkqLstkYNNX8hvADz3FarWS4sQdDA8paVaB8pQliPZOrQESV0y8JQmx0/xjU0bZcOx1My1BGErwJ4m7kLHfJKmT3VZMKDMNWtZYbwgyOcKIo2cJjKeEFVANDDeENVAhmBqQFQFScHUgmBm5EWgDNqJs2UyT1haFEkAVCSnubFMZv0/vpbleV3q1KAuC4hEht+lKTblVBwNyqjrkhXEOsNaeULw4lpu4fnch+W1XmsQAvDtV2r5qKNBam+QuJhpIxLLXQDgvZd6TBHEDDG1iHBP8E3xwg2iNiStI8I6wc6azmcBCKg3iHYC3eVmEPcpLVS4MhH5Bc7cjTPVYyMFAAAAAElFTkSuQmCC" width="25" height="25">
              <span>ZOON</span>
          </button>

          <button @click="checkYandexMaps" :disabled="isYandexMapsButtonDisabled">
              <img class="icon icons8-Refresh-Filled" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACW0lEQVRoQ+2ZgU3EMAxFPxswAhsAG8AEwATABLABMAEwATABbABMAEyAmACYAPRRLeVyaWsnjlJOjXQ66c61/eLEdtI1rMhYWxEOzCBTi6RHRPYA7APY6j4WRg/7f/ZKFNH5SwAbFs8j2RL7C6pyFRHgtABAHs21v2Q6R9EVgBMHiNIVURQRLqf7BMQdAAK+OgGa1Vgj8h7tiW8AOy0BctZoKhrblSDWOwe/tKGxROQWwGGg+Nppw8e+EuKx+3EXgArGAvIS1Yka0RAI1iQO7jkVjAXkp1YN6PTGEGJOBTMVkD4INcwUQMYgVDCtQbQQozAtQawQgzAtQc4BnEUJ5A3AZvQbu4Yw7fPvAwAPoVxLEPoR1iZCsEv4TGTHUO64ey6716qVfukk6wYhWPz67FDuKQVh7T5rgdAP7hep4H12QpmlzqX10kq1UlkTNoMUHpOHmto5ItqWP2umtMoDuSw78x75T3vkqLstkYNNX8hvADz3FarWS4sQdDA8paVaB8pQliPZOrQESV0y8JQmx0/xjU0bZcOx1My1BGErwJ4m7kLHfJKmT3VZMKDMNWtZYbwgyOcKIo2cJjKeEFVANDDeENVAhmBqQFQFScHUgmBm5EWgDNqJs2UyT1haFEkAVCSnubFMZv0/vpbleV3q1KAuC4hEht+lKTblVBwNyqjrkhXEOsNaeULw4lpu4fnch+W1XmsQAvDtV2r5qKNBam+QuJhpIxLLXQDgvZd6TBHEDDG1iHBP8E3xwg2iNiStI8I6wc6azmcBCKg3iHYC3eVmEPcpLVS4MhH5Bc7cjTPVYyMFAAAAAElFTkSuQmCC" width="25" height="25">
              <span>Яндекс</span>
          </button>

          <button @click="checkTwoGis" :disabled="isTwoGisButtonDisabled">
              <img class="icon icons8-Refresh-Filled" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACW0lEQVRoQ+2ZgU3EMAxFPxswAhsAG8AEwATABLABMAEwATABbABMAEyAmACYAPRRLeVyaWsnjlJOjXQ66c61/eLEdtI1rMhYWxEOzCBTi6RHRPYA7APY6j4WRg/7f/ZKFNH5SwAbFs8j2RL7C6pyFRHgtABAHs21v2Q6R9EVgBMHiNIVURQRLqf7BMQdAAK+OgGa1Vgj8h7tiW8AOy0BctZoKhrblSDWOwe/tKGxROQWwGGg+Nppw8e+EuKx+3EXgArGAvIS1Yka0RAI1iQO7jkVjAXkp1YN6PTGEGJOBTMVkD4INcwUQMYgVDCtQbQQozAtQawQgzAtQc4BnEUJ5A3AZvQbu4Yw7fPvAwAPoVxLEPoR1iZCsEv4TGTHUO64ey6716qVfukk6wYhWPz67FDuKQVh7T5rgdAP7hep4H12QpmlzqX10kq1UlkTNoMUHpOHmto5ItqWP2umtMoDuSw78x75T3vkqLstkYNNX8hvADz3FarWS4sQdDA8paVaB8pQliPZOrQESV0y8JQmx0/xjU0bZcOx1My1BGErwJ4m7kLHfJKmT3VZMKDMNWtZYbwgyOcKIo2cJjKeEFVANDDeENVAhmBqQFQFScHUgmBm5EWgDNqJs2UyT1haFEkAVCSnubFMZv0/vpbleV3q1KAuC4hEht+lKTblVBwNyqjrkhXEOsNaeULw4lpu4fnch+W1XmsQAvDtV2r5qKNBam+QuJhpIxLLXQDgvZd6TBHEDDG1iHBP8E3xwg2iNiStI8I6wc6azmcBCKg3iHYC3eVmEPcpLVS4MhH5Bc7cjTPVYyMFAAAAAElFTkSuQmCC" width="25" height="25">
              <span>2ГИС</span>
          </button>

          <button @click="checkNaPopravku" :disabled="isNaPopravkuButtonDisabled">
              <img class="icon icons8-Refresh-Filled" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACW0lEQVRoQ+2ZgU3EMAxFPxswAhsAG8AEwATABLABMAEwATABbABMAEyAmACYAPRRLeVyaWsnjlJOjXQ66c61/eLEdtI1rMhYWxEOzCBTi6RHRPYA7APY6j4WRg/7f/ZKFNH5SwAbFs8j2RL7C6pyFRHgtABAHs21v2Q6R9EVgBMHiNIVURQRLqf7BMQdAAK+OgGa1Vgj8h7tiW8AOy0BctZoKhrblSDWOwe/tKGxROQWwGGg+Nppw8e+EuKx+3EXgArGAvIS1Yka0RAI1iQO7jkVjAXkp1YN6PTGEGJOBTMVkD4INcwUQMYgVDCtQbQQozAtQawQgzAtQc4BnEUJ5A3AZvQbu4Yw7fPvAwAPoVxLEPoR1iZCsEv4TGTHUO64ey6716qVfukk6wYhWPz67FDuKQVh7T5rgdAP7hep4H12QpmlzqX10kq1UlkTNoMUHpOHmto5ItqWP2umtMoDuSw78x75T3vkqLstkYNNX8hvADz3FarWS4sQdDA8paVaB8pQliPZOrQESV0y8JQmx0/xjU0bZcOx1My1BGErwJ4m7kLHfJKmT3VZMKDMNWtZYbwgyOcKIo2cJjKeEFVANDDeENVAhmBqQFQFScHUgmBm5EWgDNqJs2UyT1haFEkAVCSnubFMZv0/vpbleV3q1KAuC4hEht+lKTblVBwNyqjrkhXEOsNaeULw4lpu4fnch+W1XmsQAvDtV2r5qKNBam+QuJhpIxLLXQDgvZd6TBHEDDG1iHBP8E3xwg2iNiStI8I6wc6azmcBCKg3iHYC3eVmEPcpLVS4MhH5Bc7cjTPVYyMFAAAAAElFTkSuQmCC" width="25" height="25">
              <span>НаПоправку</span>
          </button>

          <button @click="checkSber" :disabled="isSberButtonDisabled">
              <img class="icon icons8-Refresh-Filled" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACW0lEQVRoQ+2ZgU3EMAxFPxswAhsAG8AEwATABLABMAEwATABbABMAEyAmACYAPRRLeVyaWsnjlJOjXQ66c61/eLEdtI1rMhYWxEOzCBTi6RHRPYA7APY6j4WRg/7f/ZKFNH5SwAbFs8j2RL7C6pyFRHgtABAHs21v2Q6R9EVgBMHiNIVURQRLqf7BMQdAAK+OgGa1Vgj8h7tiW8AOy0BctZoKhrblSDWOwe/tKGxROQWwGGg+Nppw8e+EuKx+3EXgArGAvIS1Yka0RAI1iQO7jkVjAXkp1YN6PTGEGJOBTMVkD4INcwUQMYgVDCtQbQQozAtQawQgzAtQc4BnEUJ5A3AZvQbu4Yw7fPvAwAPoVxLEPoR1iZCsEv4TGTHUO64ey6716qVfukk6wYhWPz67FDuKQVh7T5rgdAP7hep4H12QpmlzqX10kq1UlkTNoMUHpOHmto5ItqWP2umtMoDuSw78x75T3vkqLstkYNNX8hvADz3FarWS4sQdDA8paVaB8pQliPZOrQESV0y8JQmx0/xjU0bZcOx1My1BGErwJ4m7kLHfJKmT3VZMKDMNWtZYbwgyOcKIo2cJjKeEFVANDDeENVAhmBqQFQFScHUgmBm5EWgDNqJs2UyT1haFEkAVCSnubFMZv0/vpbleV3q1KAuC4hEht+lKTblVBwNyqjrkhXEOsNaeULw4lpu4fnch+W1XmsQAvDtV2r5qKNBam+QuJhpIxLLXQDgvZd6TBHEDDG1iHBP8E3xwg2iNiStI8I6wc6azmcBCKg3iHYC3eVmEPcpLVS4MhH5Bc7cjTPVYyMFAAAAAElFTkSuQmCC" width="25" height="25">
              <span>СберЗдоровье</span>
          </button>
      </header>

      <v-table id="table"
               :lazycount="true"
               request-uri="list/getList"
               pagesize="50"
               ref="table">
          <template v-slot:header>
              <v-tr>
                  <v-th name="city" sort="city" width="45">
                      Город
                  </v-th>
                  <v-th name="name" sort="name" minwidth="250">
                      Клиника
                  </v-th>
                  <v-th name="url" sort="url" minwidth="250">
                      URL
                  </v-th>
                  <v-th name="competitor_names" width="110">
                      Конкуренты
                  </v-th>
                  <v-th name="competitor_urls" width="300">
                      URL конкурентов
                  </v-th>
                  <v-th name="competitor_is_paid_now" width="75">
                      $ сейчас
                  </v-th>
                  <v-th name="competitor_was_paid_before" width="75">
                      $ ранее
                  </v-th>
                  <v-th name="competitor_last_checked" width="100" tooltip="Дата последней проверки">
                      Проверено
                  </v-th>
              </v-tr>

              <v-tr>
                  <v-th name="city" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...cityOptions
                            ]'
                      ></v-select>
                  </v-th>
                  <v-th name="name" :debounce="true" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
                  <v-th name="url" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
                  <v-th name="competitor_names" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...competitorOptions
                            ]'
                      />
                  </v-th>
                  <v-th name="competitor_urls" v-slot="{filter}">
                      <v-input v-model="filter.value"/>
                  </v-th>
                  <v-th name="competitor_is_paid_now" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                               {
                                    value: "Да",
                                    text: "Да"
                                },
                               {
                                    value: "Ошибка",
                                    text: "Ошибка"
                                },
                                {
                                    value: "Нет",
                                    text: "Нет"
                                }
                            ]'
                      ></v-select>
                  </v-th>
                  <v-th name="competitor_was_paid_before" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                       {
                                    value: "Да",
                                    text: "Да"
                                },
                                                                {
                                    value: "Нет",
                                    text: "Нет"
                                }
                            ]'
                      ></v-select>
                  </v-th>
                  <v-th name="competitor_last_checked"  v-slot="{filter}">
                      <date-piker v-model="filter.value"/>
                  </v-th>
              </v-tr>
          </template>

          <template v-slot:row="{ item, index }">
              <v-tr class="hover">
                  <v-td name="city" highlight="*" width="45">
                      {{ item.cityObj.name_info.short }}
                  </v-td>
                  <v-td name="name" minwidth="250">
                      <div>{{ item.name }}</div>
                  </v-td>
                  <v-td name="url" minwidth="250">
                      <a class="text-ellipsis"
                         v-tooltip="`${$parent.frontendUrl}<br/>/${item.cityObj.char_id}/clinic/${item.url}`"
                         :href="`${$parent.frontendUrl}/${item.cityObj.char_id}/clinic/${item.url}`"
                         target="_blank">
                          {{ item.url }}
                      </a>
                  </v-td>
                  <v-td name="competitor_names" width="110">
                      <table>
                          <tr v-for="competitor in item.competitors_data">
                              <td>{{ competitor.name }}</td>
                          </tr>
                      </table>
                  </v-td>
                  <v-td name="competitor_urls" width="300">
                      <table>
                          <tr v-for="competitor in item.competitors_data">
                              <td :title="competitor.url" class="urlCell">
                                  <a class="text-ellipsis" :href="competitor.url" target="_blank">
                                      {{ competitor.url }}
                                  </a>
                              </td>
                          </tr>
                      </table>
                  </v-td>
                  <v-td name="competitor_is_paid_now" align="center" width="75">
                      <table style="margin: auto">
                          <tr v-for="competitor in item.competitors_data">
                              <td>
                                  <template v-if="competitor.last_checked === null">—</template>
                                  <template v-else>
                                      <template v-if="competitor.last_paid_placement_status === 1">Да</template>
                                      <template v-else-if="competitor.last_paid_placement_status === 0">Нет</template>
                                      <template v-else-if="competitor.last_paid_placement_status === -1">Ошибка</template>
                                  </template>
                              </td>
                          </tr>
                      </table>
                  </v-td>
                  <v-td name="competitor_was_paid_before" align="center" width="75">
                      <table style="margin: auto">
                          <tr v-for="competitor in item.competitors_data">
                              <td>
                                  {{ competitor.was_paid_before ? 'Да' : (competitor.last_checked === null ? '—' : 'Нет') }}
                              </td>
                          </tr>
                      </table>
                  </v-td>
                  <v-td name="competitor_last_checked" width="100">
                      <table style="margin: auto">
                          <tr v-for="competitor in item.competitors_data">
                              <td v-if="competitor.last_checked">
                                  {{ competitor.last_checked | formatDate }}
                              </td>
                              <td v-else>
                                  —
                              </td>
                          </tr>
                      </table>
                  </v-td>
              </v-tr>
          </template>
      </v-table>
  </main>
</template>

<script>
import ParserLaunchDialog from "./ParserLaunchDialog.vue";
export default {
    components: {ParserLaunchDialog},
    props: {
        competitorOptions: {
            type: Array,
            required: true
        },
        cityOptions: {
            type: Array,
            required: true
        },
        disableProDoctorov: {
            type: Boolean,
            default: false,
        },
        disableZoon: {
            type: Boolean,
            default: false,
        },
        disableYandex: {
            type: Boolean,
            default: false,
        },
        disableTwoGis: {
            type: Boolean,
            default: false,
        },
        disableNaPopravku: {
            type: Boolean,
            default: false,
        },
        disableSber: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            isProDoctorovButtonDisabled: this.disableProDoctorov,
            isZoonButtonDisabled: this.disableZoon,
            isYandexMapsButtonDisabled: this.disableYandex,
            isTwoGisButtonDisabled: this.disableTwoGis,
            isNaPopravkuButtonDisabled: this.disableNaPopravku,
            isSberButtonDisabled: this.disableSber,
        };
    },

    methods: {
        checkProDoctorov () {
            this.$refs.parserDialog.show('proDoctorov', 'ПроДокторов');
        },
        checkZoon () {
            this.$refs.parserDialog.show('zoon', 'ZOON');
        },
        checkYandexMaps () {
            this.$refs.parserDialog.show('yandex', 'Яндекс');
        },
        checkTwoGis () {
            this.$refs.parserDialog.show('twoGis', '2ГИС');
        },
        checkNaPopravku () {
            this.$refs.parserDialog.show('naPopravku', 'НаПоправку');
        },
        checkSber () {
            this.$refs.parserDialog.show('sber', 'СберЗдоровье');
        },
        disableParserBtn (parser) {
            switch (parser) {
                case 'proDoctorov':
                    this.isProDoctorovButtonDisabled = true;
                    break;
                case 'zoon':
                    this.isZoonButtonDisabled = true;
                    break;
                case 'yandex':
                    this.isYandexMapsButtonDisabled = true;
                    break;
                case 'twoGis':
                    this.isTwoGisButtonDisabled = true;
                    break;
                case 'naPopravku':
                    this.isNaPopravkuButtonDisabled = true;
                    break;
                case 'sber':
                    this.isSberButtonDisabled = true;
                    break;
            }
        },
    }
}
</script>

<style>
    .urlCell {
        width: 300px !important;
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
